import { queryOptions } from '@tanstack/react-query';

import { buildURL } from '@/shared/fetch';

import { AnyCard } from './types';

// eslint-disable-next-line import/prefer-default-export
export const getCardsQueryOptions = (habitatId: string, tab: string) =>
  queryOptions({
    queryKey: ['cards', 'list', habitatId, tab],
    queryFn: async ({ signal }) => {
      const { cards } = await fetch(buildURL(`/habitats/${habitatId}/cards/tabs/${tab}`), {
        signal,
        headers: {
          Accept: 'application/json',
        },
        credentials: 'include',
      }).then((res) => res.json() as Promise<{ cards: AnyCard[] }>);

      const cardsWithQuestions = await Promise.all(
        cards.map(async (card) => {
          // quiz cards have trivia question IDs in data which needs to be mapped
          // into questions, and we also need to map answers
          if (card.type === 'QUIZ_CARD_TYPE') {
            const cardData = await fetch(buildURL(`cards/${card._id}/questions`), {
              signal,
              headers: {
                Accept: 'application/json',
              },
              credentials: 'include',
            }).then((res) => res.json());
            return { ...card, data: cardData };
          }
          return card;
        }),
      );
      return cardsWithQuestions as AnyCard[];
    },
  });
